// Layer: Page (UI) – chỉ render JSX, gọi hook domain từ features.
import React from 'react';
import { Row, Col, Alert } from 'antd';
import { Eye, EyeOff } from 'lucide-react';
import { useResetPassword } from '@/features/auth/useResetPassword';
import sdtcLogo from '@/assets/sdtc.svg';
import loginIllustration from '@/assets/login.svg';
import passIcon from '@/assets/pass.svg';
import styles from './ResetPasswordPage.module.css';

export const ResetPasswordPage: React.FC = () => {
  const {
    password,
    confirmPassword,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    passwordError,
    confirmPasswordError,
    loading,
    error,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleSubmit,
    handleGoToLogin,
  } = useResetPassword();

  return (
    <Row className={styles.container}>
      <Col xs={0} md={14} className={styles.leftColumn}>
        <div className={styles.textContainer}>
          <h1 className={styles.mainTitle}>
            Hệ thống Quản lý Nhân sự Toàn diện
          </h1>
          <p className={styles.subtitle}>
            Nâng cao hiệu quả làm việc, tối ưu quy trình và kết nối con người trong tổ chức của bạn.
          </p>
        </div>
        <div className={styles.imageContainer}>
          <img src={loginIllustration} alt="Login Illustration" className={styles.illustration} />
        </div>
      </Col>

      <Col xs={24} md={10} className={styles.rightColumn}>
        <div className={styles.formContainer}>
          <div className={styles.logoContainer}>
            <img src={sdtcLogo} alt="SDTC Logo" />
          </div>
          <h2 className={styles.formTitle}>
            Đặt lại mật khẩu
          </h2>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              style={{ marginBottom: 16 }}
            />
          )}

          <form onSubmit={handleSubmit} className={styles.resetPasswordForm}>
            <div className={styles.formGroup}>
              <label htmlFor="password" className={styles.formLabel}>Mật khẩu</label>
              <div className={styles.inputWrapper}>
                <img src={passIcon} alt="Password" className={styles.inputIcon} />
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="Nhập mật khẩu"
                  autoComplete="new-password"
                  className={`${styles.customInput} ${styles.passwordInput} ${passwordError ? styles.inputError : ''}`}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className={styles.eyeButton}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                >
                  {showPassword ? (
                    <Eye size={20} color="#999" />
                  ) : (
                    <EyeOff size={20} color="#999" />
                  )}
                </button>
              </div>
              {passwordError && <span className={styles.errorMessage}>{passwordError}</span>}
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="confirmPassword" className={styles.formLabel}>Xác nhận mật khẩu</label>
              <div className={styles.inputWrapper}>
                <img src={passIcon} alt="Password" className={styles.inputIcon} />
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  placeholder="Xác nhận mật khẩu"
                  autoComplete="new-password"
                  className={`${styles.customInput} ${styles.passwordInput} ${confirmPasswordError ? styles.inputError : ''}`}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className={styles.eyeButton}
                  tabIndex={-1}
                  aria-label={showConfirmPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                >
                  {showConfirmPassword ? (
                    <Eye size={20} color="#999" />
                  ) : (
                    <EyeOff size={20} color="#999" />
                  )}
                </button>
              </div>
              {confirmPasswordError && <span className={styles.errorMessage}>{confirmPasswordError}</span>}
            </div>

            <button type="submit" disabled={loading} className={styles.submitButton}>
              {loading ? 'Đang đặt lại...' : 'Đặt lại mật khẩu'}
            </button>
          </form>

          <div className={styles.backToLoginContainer}>
            <button
              type="button"
              onClick={handleGoToLogin}
              className={styles.backToLoginButton}
            >
              Trở về Đăng nhập
            </button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

